<crm-single-select
  #singleSelectComponent
  [options]="categories"
  [(selectedItem)]="_selectedCategory"
  (selectedItemChange)="onSelect($event)"
  [label]="isFloatLabel ? 'Категория ТС' : ''"
  [showClear]="showClear"
  [placeholder]="placeholder"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [appendTo]="appendTo"
  [disabled]="disabled"
  [loading]="loading || defaultCategoryLoading"
  filterBy="name"
  (onShow)="onShowPanel()"
  (onFilter)="search($event.filter)">
  <ng-template #footerTemplate>
    <crm-spinner
      *ngIf="paginationLoading"
      top=""
      text=""
      [height]="35"
      [width]="35"
      bottom=""></crm-spinner>
  </ng-template>
</crm-single-select>
